import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, Transition } from "@headlessui/react";
import * as React from "react";
import { useState } from "react";

interface Props {
  link: string | React.ReactNode;
  side?: "right" | "left";
  mobileAbsolute?: boolean;
  children?: React.ReactNode;
}

const MenuEntry: React.FC<Props> = ({
  link, side = "left", mobileAbsolute = false, children,
}) => {
  const [open, setOpen] = useState(false);

  const displayClass = mobileAbsolute ? `absolute ${side}-0 shadow-lg bg-white ring-1` : `md:absolute ${side}-0 md:shadow-lg md:bg-white md:ring-1`;

  return (
    <Menu as="div" className="relative inline-block text-left md:z-[40]" onMouseLeave={() => setOpen(false)}>
      <div>
        <Menu.Button onClick={() => setOpen(!open)}>
          <span className="flex content-center">
            {link}
            {children && <span><FontAwesomeIcon icon={faCaretDown} className={`ml-1 transform transition duration-300 ease-in-out ${open ? "rotate-180" : ""}`} /></span>}
          </span>
        </Menu.Button>
      </div>
      {children && (
        <Transition
          show={open}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className={`${displayClass} md:w-56 rounded-md ring-black/5 focus:outline-hidden md:z-[40]`}>
            <div className="py-1 mt-2 md:z-[40]">
              {React.Children.map(children, (child) => (
                <>
                  {child && (
                    <Menu.Item>
                      <div onKeyDown={() => ({})} onClick={() => setOpen(false)}>
                        {React.cloneElement(child as React.ReactElement, {
                          className: "hover:bg-gray-100 hover:text-gray-900 text-gray-700 block px-4 py-2 text-lg w-full",
                        })}
                      </div>
                    </Menu.Item>
                  )}
                </>
              ))}
            </div>
          </Menu.Items>
        </Transition>
      )}
    </Menu>
  );
};

export default MenuEntry;
